import React from 'react';

/**
 * Reusable ResUI card (Figma Card 622-3301). White surface, 1px neutral border,
 * rounded-xl, p-4. Styling lives in `.resui-card` (src/styles/resui-components.css),
 * so it's consistent everywhere.
 *
 *   <Card>…</Card>                         // static card
 *   <Card interactive onClick={…}>…</Card> // clickable card that lifts on hover
 *   <Card as="li" className="my-extra">…</Card>
 *
 * Wrap a set of cards in <CardGrid> for the responsive tile layout used on the
 * Data Sources page.
 */
export default function Card({
  as: Tag = 'div',
  interactive = false,
  className = '',
  children,
  ...props
}) {
  const classes = ['resui-card', interactive ? 'resui-card--interactive' : '', className]
    .filter(Boolean)
    .join(' ');
  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
}

/** Responsive grid wrapper for cards (matches the Data Sources tile layout). */
export function CardGrid({ as: Tag = 'div', className = '', children, ...props }) {
  const classes = ['resui-card-grid', className].filter(Boolean).join(' ');
  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
}
